import { jsx as e } from "react/jsx-runtime";
import { c as i } from "./clsx-OuTLNxxd.js";
import { i as n } from "./index-BNbiCIVA.js";
const f = ({ color: o, size: s, opacity: t = 1, className: l }) => {
  const r = i(n({ color: o, size: s }), l);
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "13",
      height: "8",
      viewBox: "0 0 13 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "presentation",
      focusable: !1,
      className: r,
      "aria-hidden": !0,
      style: { "--opacity": t },
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.45499 3.01727L2.12864 7.34363L0.691345 5.90634L6.45499 0.142694L12.2186 5.90634L10.7813 7.34363L6.45499 3.01727Z",
          fill: "currentColor"
        }
      )
    }
  );
};
export {
  f as C
};
